import { useState, useEffect } from "react";
import { C, font } from "../../styles/tokens";

export function OtpVerification({
  onVerify,
  onResend,
  loading,
  error,
  expiresAt,
}) {
  const [otp, setOtp] = useState("");
  const [countdown, setCountdown] = useState(60);
  const [canResend, setCanResend] = useState(false);

  useEffect(() => {
    if (countdown <= 0) {
      setCanResend(true);
      return;
    }
    const timer = setInterval(() => setCountdown((c) => c - 1), 1000);
    return () => clearInterval(timer);
  }, [countdown]);

  const handleResend = () => {
    setOtp("");
    setCountdown(60);
    setCanResend(false);
    if (onResend) onResend();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (otp.trim().length === 6 && !loading) {
      onVerify(otp.trim());
    }
  };

  return (
    <div style={containerStyle}>
      <h3 style={headingStyle}>Enter Verification OTP</h3>
      <p style={subheadingStyle}>
        Please enter the 6-digit OTP sent to your registered mobile number via
        Cashfree.
      </p>

      <form onSubmit={handleSubmit} style={formStyle}>
        <input
          type="text"
          maxLength={6}
          placeholder="123456"
          value={otp}
          onChange={(e) => setOtp(e.target.value.replace(/\D/g, ""))}
          style={inputStyle}
          disabled={loading}
          autoFocus
        />

        {error && <div style={errorStyle}>{error}</div>}

        <div className="flex flex-col sm:flex-row gap-2.5 sm:gap-0 items-stretch sm:items-center justify-between mt-1">
          <button
            type="submit"
            disabled={otp.length !== 6 || loading}
            className="w-full sm:w-auto min-h-[44px] sm:min-h-0 px-4 py-2 text-sm sm:text-[13px] font-semibold text-white rounded transition flex items-center justify-center cursor-pointer disabled:cursor-not-allowed"
            style={{
              background: otp.length === 6 && !loading ? C.blue : C.textLight,
              cursor: otp.length === 6 && !loading ? "pointer" : "not-allowed",
              fontFamily: font,
            }}
          >
            {loading ? "Verifying OTP..." : "Verify OTP"}
          </button>

          <button
            type="button"
            onClick={handleResend}
            disabled={!canResend || loading}
            className="text-xs font-medium py-1 text-center cursor-pointer"
            style={{
              background: "none",
              border: 0,
              color: canResend && !loading ? C.blue : C.textMed,
              cursor: canResend && !loading ? "pointer" : "default",
              fontFamily: font,
            }}
          >
            {canResend ? "Resend OTP" : `Resend in ${countdown}s`}
          </button>
        </div>
      </form>
    </div>
  );
}

const containerStyle = {
  background: C.bgMuted || "#f8fafc",
  border: `1px solid ${C.divider || "#e2e8f0"}`,
  borderRadius: 8,
  padding: 16,
  marginTop: 12,
  fontFamily: font,
};

const headingStyle = {
  fontSize: 14,
  fontWeight: 600,
  margin: "0 0 4px",
  color: C.textDark,
};

const subheadingStyle = {
  fontSize: 12,
  color: C.textMed,
  margin: "0 0 12px",
};

const formStyle = {
  display: "flex",
  flexDirection: "column",
  gap: 10,
};

const inputStyle = {
  fontSize: 18,
  letterSpacing: 4,
  textAlign: "center",
  padding: "8px 12px",
  border: `1px solid ${C.dividerStrong || "#cbd5e1"}`,
  borderRadius: 6,
  width: "100%",
  boxSizing: "border-box",
  fontFamily: font,
};

const actionRowStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginTop: 4,
};

const buttonStyle = {
  padding: "8px 16px",
  fontSize: 13,
  fontWeight: 600,
  color: "white",
  border: 0,
  borderRadius: 4,
  fontFamily: font,
};

const resendButtonStyle = {
  background: "none",
  border: 0,
  fontSize: 12,
  fontWeight: 500,
  fontFamily: font,
};

const errorStyle = {
  fontSize: 12,
  color: C.red || "#ef4444",
  background: C.redLight || "#fef2f2",
  padding: "6px 10px",
  borderRadius: 4,
};
